module.exports = __webpack_public_path__ + "img/cafe_international-lg.d41b319a.webp";